import Button from "@material-ui/core/Button/Button";
import FormControl from "@material-ui/core/FormControl/FormControl";
import FormGroup from "@material-ui/core/FormGroup/FormGroup";
import FormLabel from "@material-ui/core/FormLabel/FormLabel";
import Input from "@material-ui/core/Input/Input";
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment";
import InputLabel from "@material-ui/core/InputLabel/InputLabel";
import List from "@material-ui/core/List/List";
import ListItem from "@material-ui/core/ListItem/ListItem";
import AddCircle from "@material-ui/icons/AddCircle";
import Delete from "@material-ui/icons/Delete";
import * as React from "react";
import { LinkModel } from "../model/autogen/LinkModel";
import { NBSP } from "../utils/string";
import { isArrayNullOrEmpty } from "../utils/array";

interface ILinkItemEditorProps {
    index: number;
    title: string;
    url: string;
    onChange: (index: number, title: string, url: string) => void;
    onRequestRemoval: (index: number) => void;
}

interface ILinkItemEditorState {

}

class LinkItemEditor extends React.Component<ILinkItemEditorProps, ILinkItemEditorState> {
    constructor(props: ILinkItemEditorProps) {
        super(props);
    }
    private onLinkUrlhanged = (e: any) => {
        this.props.onChange(this.props.index, this.props.title, e.target.value);
    }
    private onLinkDescriptionChanged = (e: any) => {
        this.props.onChange(this.props.index, e.target.value, this.props.url);
    }
    private onRemove = (e: any) => {
        if (confirm(`Are you sure you want to remove this item?`)) {
            this.props.onRequestRemoval(this.props.index);
        }
    }
    render(): JSX.Element {
        const { title, url } = this.props;
        const adorn = <InputAdornment position="end"><Button color="secondary" onClick={this.onRemove}><Delete />{NBSP}Remove</Button></InputAdornment>;
        return <ListItem>
            <FormControl fullWidth={true}>
                <FormControl>
                    <InputLabel>Description</InputLabel>
                    <Input fullWidth onChange={this.onLinkDescriptionChanged} name="title" value={title} endAdornment={adorn} />
                </FormControl>
                <FormGroup>
                    <FormLabel>URL</FormLabel>
                    <Input fullWidth onChange={this.onLinkUrlhanged} name="title" value={url} />
                </FormGroup>
            </FormControl>
        </ListItem>;
    }
}

export interface ILinkCollectionEditorProps {
    items: LinkModel[];
    onChange: (index: number, title: string, url: string) => void;
    onAdd: () => void;
    onRemove: (index: number) => void;
    noItemsPlaceholder?: JSX.Element;
}

export interface ILinkCollectionEditorState {

}

export class LinkCollectionEditor extends React.Component<ILinkCollectionEditorProps, ILinkCollectionEditorState> {
    constructor(props: ILinkCollectionEditorProps) {
        super(props);
    }
    render(): JSX.Element {
        const { items, noItemsPlaceholder } = this.props;
        return <List>
            <Button variant="contained" fullWidth onClick={this.props.onAdd}><AddCircle />{NBSP}Add Link</Button>
            {(() => {
                if (isArrayNullOrEmpty(items)) {
                    return noItemsPlaceholder;
                } else {
                    return this.props.items.map((item, index) => <LinkItemEditor key={index} index={index} title={item.title} url={item.url} onChange={this.props.onChange} onRequestRemoval={this.props.onRemove} />);
                }
            })()}
        </List>;
    }
}


// WEBPACK FOOTER //
// ./src/components/link-collection-editor.tsx